import { render, staticRenderFns } from "./giftdialog.vue?vue&type=template&id=6c17ed39&scoped=true"
import script from "./giftdialog.vue?vue&type=script&lang=js"
export * from "./giftdialog.vue?vue&type=script&lang=js"
import style0 from "./giftdialog.vue?vue&type=style&index=0&id=6c17ed39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17ed39",
  null
  
)

export default component.exports